import Form from 'components/Form';
import Implement from 'components/Implement';
import WithField from 'components/WithField';
import EventTypeField from 'components/fields/EventTypeField';
import NotesField from 'components/fields/NotesField';
import SelectCalibrationKindField from 'components/fields/SelectCalibrationKindField';
import SelectPartField from 'components/fields/SelectPartField';
import SelectUnitField from 'components/fields/SelectUnitField';
import ServiceDateField from 'components/fields/ServiceDateField';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const LogServiceFormFields: FunctionComponent<Props> = ({
    assetId,
    form,
    isCalibration,
    isPartRequired,
    isPartVisible,
    isUnitVisible,
    testId = TEST_ID,
    unitPartType
}) => {
    const { ADD_NOTES, CHOOSE_CALIBRATION_TYPE, CHOOSE_PART, CHOOSE_UNIT, PHOTOS } =
        useTranslation();

    const { control } = form;

    return (
        <Form form={form} testId={testId}>
            <EventTypeField control={control} isPlain isRequired name='eventType' />

            {isPartVisible && (
                <SelectPartField
                    assetId={assetId}
                    control={control}
                    isPlain
                    isRequired={isPartRequired}
                    name='part'
                    placeholder={CHOOSE_PART}
                />
            )}

            {isCalibration && (
                <SelectCalibrationKindField
                    control={control}
                    isPlain
                    isRequired
                    name='calibrationKind'
                    placeholder={CHOOSE_CALIBRATION_TYPE}
                />
            )}

            {isUnitVisible && (
                <SelectUnitField
                    assetId={assetId}
                    control={control}
                    isPlain
                    isRequired
                    name='unit'
                    partType={unitPartType}
                    placeholder={CHOOSE_UNIT}
                />
            )}

            <ServiceDateField control={control} isPlain isRequired name='performedOn' />

            <NotesField control={control} isPlain name='notes' placeholder={ADD_NOTES} />

            <WithField isPlain label={PHOTOS}>
                <Implement />
            </WithField>
        </Form>
    );
};

export default LogServiceFormFields;
